import commonNav from '@/components/common-nav/index.vue';
import common from '@/util/common';
import {
	Swiper,
	SwiperSlide
} from 'vue-awesome-swiper';
// import common from '@/util/common';
import {
	createNamespacedHelpers
} from 'vuex';
const sroreName = {
	accountRecharge: 'accountRecharge',
};
const {
	mapState,
	mapActions,
} = createNamespacedHelpers(sroreName.accountRecharge);
export default {
	data() {
		return {
			swiperOption: {
				//自动轮播
				autoplay: {
					delay: 5000,
					//当用户滑动图片后继续自动轮播
					disableOnInteraction: false
				},
				//开启循环模式
				loop: true
			},
			moneyList: [],
			money: '', //充值金额
			tabIndex: 0, //默认选tab
			wxAppid: '',
			code: '',
			order_no: '',//订单num
			bankRechargeData: '',//建行支付
			loginWay: '',//登录环境，提供给支付用，建行环境0，非建行2
		};
	},
	components: {
		'common-nav': commonNav,
		Swiper,
		SwiperSlide
	},
	async mounted() {
		const getConfigInfo = JSON.parse(sessionStorage.getItem('configInfo'));
		this.moneyList = getConfigInfo.recharge_amount;
		this.money = getConfigInfo.recharge_amount[0];
		this.loginWay = getConfigInfo.loginWay;
		console.log('this.moneyList', this.moneyList, this.money,this.loginWay)
		// console.log('WeixinJSBridge',WeixinJSBridge)
		this.getUrlSearchParam();
	},
	watch: {

	},
	computed: {
		...mapState({
			rechargeData(state) {
				return state.rechargeData
			}
		})
	},
	methods: {
		...mapActions({
			recharge: 'recharge',
			wxRecharge: 'wxRecharge',
			zfbRecharge: 'zfbRecharge',
			postWxLogin: 'postWxLogin',
			postRedirect: 'postRedirect',
			getPayInfo: 'getPayInfo',
			bankRecharge: 'bankRecharge'
		}),
		getUrlSearchParam(){
			const searchQuery = decodeURIComponent(location.search);
			const urlSearchParamsObj = new URLSearchParams(searchQuery);
			const isWxEmpowerFlag = urlSearchParamsObj.get('isWxEmpowerFlag');
			if(isWxEmpowerFlag && isWxEmpowerFlag == 1){
				this.money = urlSearchParamsObj.get('money');
				this.tabIndex = urlSearchParamsObj.get('tabIndex');
				this.code = urlSearchParamsObj.get('code');
				console.log('search',searchQuery,isWxEmpowerFlag,this.money,this.tabIndex);
				this.postRedirectHandle(this.code);
			}
		},
		selectMoney(index) {
			this.money = this.moneyList[index];
			this.tabIndex = index;
		},
		async submit(e) {
			console.log(e);
			const param = {
				content: this,
				data: {
					money: this.money
				}
			};
			await this.recharge(param);
			console.log('rechargeData over');
			this.$nextTick(() => {
				console.log(this.$refs.rechargeForm);
				this.$refs.rechargeForm.submit();
			})
		},
		async postRedirectHandle(code){
			const param = {
				content: this,
				data: {
					code: code,
				}
			};
			const redirectData = await this.postRedirect(param);
			console.log('redirectData',redirectData,redirectData.data.msg);
			if (redirectData && redirectData.code == 1) {
				/* 重新给token做一下cookie */
				document.cookie = `${encodeURIComponent("token")}=${encodeURIComponent(redirectData.data.token)}`;
				this.wxSubmit();
			}
		},
		async wxSubmit() {
			const param = {
				content: this,
				data: {
					money: this.money,
					type: 'js'
				}
			};
			const wxRechargeData = await this.wxRecharge(param);
			this.order_no = wxRechargeData.data.order_no;
			this.loadWxJsSDK(wxRechargeData);
		},
		loadWxJsSDK(params) {
			if (typeof window.WeixinJSBridge === 'undefined') {
				if (document.addEventListener) {
					document.addEventListener('WeixinJSBridgeReady', () => {
						this.onBridgeReady(params);
					}, false)
				} else if (document.attachEvent) {
					document.attachEvent('WeixinJSBridgeReady', () => {
						this.onBridgeReady(params);
					})
					document.attachEvent('onWeixinJSBridgeReady', () => {
						this.onBridgeReady(params);
					})
				}
			} else {
				this.onBridgeReady(params)
			}
		},
		onBridgeReady(params) {
			console.log('WeixinJSBridge', window.WeixinJSBridge, params);
			window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
				"appId": params.data.param.appId, //公众号ID，由商户传入     
				"timeStamp": params.data.param.timeStamp, //时间戳，自1970年以来的秒数     
				"nonceStr": params.data.param.nonceStr, //随机串     
				"package": params.data.param.package,
				"signType": params.data.param.signType, //微信签名方式：     
				"paySign": params.data.param.paySign //微信签名 
			},
			(res) => {
				console.log('res', res)
				this.getPayInfo();
			});
		},
		async getPayInfo(){
			const that = this;
			const param = {
				content: this,
				data: {
					order_no: this.order_no
				}
			};
			const getPayInfoData = await this.getPayInfo(param);
			if(getPayInfoData.code == 1){
				common.toast(getPayInfoData.msg, 'success',()=>{
					common.jump(that,'myInfo');
				});
			}
		},
		async wxEmpowerHandle(){
			const href = location.href;
			const url = `${href.split('?')[0]}/?isWxEmpowerFlag=1&money=${this.money}&tabIndex=${this.tabIndex}`;
			const redirect_uri = encodeURIComponent(url);
			console.log(redirect_uri,url)
			const param = {
				content: this
			};
			const wxLoginData = await this.postWxLogin(param);
			if(wxLoginData && wxLoginData.code == 1){
				this.wxAppid = wxLoginData.data;
				window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
			}
		},
		async zfbSubmit(e) {
			console.log(e);
			const param = {
				content: this,
				data: {
					money: this.money
				}
			};
			const zfbRechargeData = await this.zfbRecharge(param);
			console.log('zfbRechargeData', zfbRechargeData)
			if (zfbRechargeData && zfbRechargeData.code == 1) {
				const divForm = document.getElementsByTagName('divform')
				if (divForm.length) {
					document.body.removeChild(divForm[0])
				}
				const divDom = document.createElement('divform')
				divDom.innerHTML = zfbRechargeData.msg // res.data就是支付宝返回给你的form
				document.body.appendChild(divDom);
				console.log(document.forms['alipaysubmit'], 1111);
				document.forms['alipaysubmit'].submit();
			}
		},
		async bankRechargeHandle(){
			const param = {
				content: this,
				data: {
					money: this.money,
					type: this.loginWay//建行环境0，非建行2
				}
			};
			const getBankRechargeData = await this.bankRecharge(param);
			console.log('getBankRechargeData', getBankRechargeData)
			if (getBankRechargeData && getBankRechargeData.code == 1) {
				// this.bankRechargeData = getBankRechargeData.data;
				// this.$nextTick(() => {
				// 	console.log(this.$refs.bankRechargeForm);
				// 	this.$refs.bankRechargeForm.submit();
				// })
				location.href = getBankRechargeData.data;
			}
		}
		
	}
};
